<template>
    <div class="app">
        <div class="banner" style="min-height: 596px;cursor: pointer;" @click="btnBanner">
            <img :src="centerBanner" alt="" >
        </div>
        <div class="contact_us">
            <div class="tit">
                联系我们
            </div>
            <div class="logo">
                <img src="@/assets/img/bg/down.png" alt="">
            </div>
            <div class="imgs">
                <div class="img_box" v-for="item in dataone" :key="item.id">
                    <div class="img">
                        <img :src="item.show_img" alt="">
                    </div>
                    <div class="lang">
                        <div class="cn">{{ item.title }}</div>
                        <div class="en">{{ item.t_desc }}</div>
                    </div>
                    <div class="email">
                        {{ item.desc }}
                    </div>
                </div>
            </div>
        </div>

        <div class="follow_us" style="background-color: #f9fbfd;">
            <div class="tit">
                关注我们
            </div>
            <div class="logo">
                <img src="@/assets/img/bg/down.png" alt="">
            </div>
            <div class="text">
                可通过下面各种方式关注我们
            </div>
            <div class="imgs">
                <div class="img" v-for="item in datatwo" :key="item.id">
                    <img :src="item.show_img" alt="" style="margin-bottom: 10px;">
                    {{ item.title }}
                </div>
                <div>
                </div>
            </div>
        </div>

        <div class="company_Detail">
            <div class="map">
                <img :src="pageData.web_company_place" alt="">
            </div>
            <div class="info">
                <div class="logo">
                    <img src="@/assets/img/bg/addLogo.png" alt="">
                </div>
                <!-- <div class="slogan">{{ pageData.web_site_slogan }}</div> -->
                <div class="name">{{ pageData.web_company_name }}</div>
                <div class="en_name">{{ pageData.web_company_en_name }}</div>
                <div class="tel"><img src="@/assets/img/bg/pgone.png" style="width: 23px;height: 22px;margin-right: 7px;" alt="">电话：{{ pageData.web_company_tel }}</div>
                <div class="code"><img src="@/assets/img/bg/email.png" style="width: 21px;height: 14px;margin-left: 1px;margin-right: 8px;" alt="">邮编：{{ pageData.web_company_zip_code }}</div>
                <div class="city"><img src="@/assets/img/bg/address.png" style="width: 16px;height: 24px;margin-left: 4px;margin-right: 10px;" alt="">地址：{{ pageData.web_company_city }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            pageData: {},
            dataone: {},
            datatwo: {},
            centerBanner: '',
        }
    },
    methods: {
        getData() {
            axios({
                url: this.base_url.base_url + '/index.php/index/index/web_conf',
                method: 'get',
            }).then((res) => {
                this.pageData = res.data.data
            }).catch((err) => {
                console.log(err);
            })
        },
        getone() {
            axios({
                url: this.base_url.base_url + '/index.php/index/index/news_list?nid=13&cid=22',
                method: 'get',
            }).then((res) => {
                this.dataone = res.data.data.news_data
            }).catch((err) => {
                console.log(err);
            })
        },
        gettwo() {
            axios({
                url: this.base_url.base_url + '/index.php/index/index/news_list?nid=13&cid=28',
                method: 'get',
            }).then((res) => {
                this.datatwo = res.data.data.news_data
            }).catch((err) => {
                console.log(err);
            })
        },
        getbanner() {
            axios({
                url: this.base_url.base_url + '/index.php/index/index/navigation_list',
                method: 'get',
            }).then((res) => {
                this.centerBanner = res.data.data.top_list[4].banner_list[0].img
                this.link = res.data.data.top_list[4].banner_list[0].link
            }).catch((err) => {
                console.log(err);
            })
        },
        btnBanner(){
            window.open(this.link,"_blank");
        }
    },
    created() {
        this.getData()
        this.getone()
        this.gettwo()
        this.getbanner()
    }
}
</script>

<style scoped lang="scss">
.app {
    .banner {
        width: 100%;
        height: 536px;
        // background-color: blue;
        overflow: hidden;

        img {
            width: 100%;
            // height: 536px;
        }
    }

    .contact_us {
        width: 100%;
        height: 471px;
        background-color: white;
        padding-top: 78px;
        text-align: center;

        .tit {
            // width: 131px;
            height: 32px;
            font-size: 34px;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            line-height: 0px;
        }

        .logo {
            width: 232px;
            height: 23px;
            // background-color: #000;
            margin: 26px auto 72px;

            img {
                width: 232px;
                height: 23px;
            }
        }


        .imgs {
            display: flex;
            justify-content: center;

            .img_box {
                width: 260px;
                height: 200px;
                margin: 0 120px;
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                align-items: center;
                font-family: SourceHanSansCN, SourceHanSansCN;
                font-weight: 400;
                color: #666666;
                font-size: 18px;

                .img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 12px;
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }
                .lang {
                    font-size: 24px;
                    color: #666666;
                    margin-bottom: 30px;
                    .cn {
                        color: #333333;
                        margin-bottom: 10px;
                    }

                    .en {
                        font-size: 18px;

                    }
                }

                .email {
                    color: #666666;
                    font-size: 18px;
                }

            }
        }
    }

    .follow_us {
        width: 100%;
        height: 471px;
        background-color: white;
        padding-top: 78px;
        text-align: center;

        .tit {
            // width: 131px;
            height: 32px;
            font-size: 34px;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            line-height: 0px;
        }

        .logo {
            width: 232px;
            height: 23px;
            // background-color: #000;
            margin: 24px auto 40px;

            img {
                width: 232px;
                height: 23px;
            }
        }

        .text {
            margin: 0 auto 60px;
            // width: 361px;
            height: 27px;
            font-size: 28px;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 300;
            color: #333333;
        }

        .imgs {
            display: flex;
            justify-content: center;

            .img {
                width: 148px;
                height: 145px;
                // background: pink;
                margin: 0 120px;

                img {
                    width: 148px;
                    height: 145px;
                }
            }
        }
    }

    .company_Detail {
        width: 100%;
        height: 529px;
        // background-color: pink;
        padding-top: 110px;
        display: flex;
        justify-content: center;

        .map {
            width: 758px;
            height: 393px;
            // background-color: white;
            margin-right: 104px;

            img {
                width: 758px;
                height: 393px;
            }
        }

        .info {
            width: 400px;
            height: 343px;
            padding-top: 24px;

            // background-color: #fff;
            .logo {
                width: 400px;
                height: 90px;

                img {
                    width: 400px;
                    height: 90px;
                }
            }

            .slogan {
                margin-top: -10px;
                text-align: center;
                font-size: 18px;
            }

            .name {
                margin-top: 30px;
                font-size: 20px;
                font-weight: 700;
                color: #333333;
            }

            .en_name {
                font-size: 14px;
                color: #333;
                margin-bottom: 34px;
                margin-top: 11px;

            }

            .tel {
                font-size: 18px;
                color: #666666;
                margin-top: 10px;

            }

            .code {
                font-size: 18px;
                color: #666666;
                margin-top: 10px;

            }

            .city {
                font-size: 18px;
                color: #666666;
                margin-top: 10px;
            }
        }
    }
}</style>
